/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SignaturePad from "signature_pad";

let signCanvas;
const __vue_script__ = {
  name: "SignatureField",
  props: ["value", "editing"],
  emits: ["input"],
  data: () => {
    return {};
  },
  mounted() {
    signCanvas = new SignaturePad(this.$refs.signCanvas);
    signCanvas.addEventListener("endStroke", () => {
      this.$emit("input", signCanvas.toDataURL());
    });
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal) {
        signCanvas.fromDataURL(newVal);
      } else {
        signCanvas.fromDataURL("");
      }
    },
  },
  methods: {
    clearSignature() {
      signCanvas.clear();
      this.$emit("input", signCanvas.toDataURL());
    },
  },
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "text-center" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.editing,
            expression: "editing"
          }
        ],
        staticClass: "signature-field mx-auto"
      },
      [
        _c("canvas", {
          ref: "signCanvas",
          staticClass: "signature-canvas",
          attrs: { width: "320", height: "200" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "signature-btn-row editing" }, [
          _c(
            "button",
            {
              staticClass: "signature-reset btn icon-btn",
              attrs: { type: "button" },
              on: { click: _vm.clearSignature }
            },
            [
              _c("svg", { staticClass: "icon icon-sm" }, [
                _c("use", { attrs: { href: "#icon-refresh" } })
              ])
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _vm.value
      ? _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.editing,
              expression: "!editing"
            }
          ],
          staticClass: "signature-canvas",
          attrs: { src: _vm.value }
        })
      : _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.editing,
              expression: "!editing"
            }
          ],
          staticClass: "signature-canvas mx-auto"
        })
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-1de2b263_0", { source: "\n.signature-field[data-v-1de2b263] {\n  min-height: 110px;\n  background: #fff;\n  border: 1px solid #f4f5f6;\n  border-radius: 6px;\n  position: relative;\n  width: 320px;\n}\n.signature-btn-row[data-v-1de2b263] {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n}\n.signature-canvas[data-v-1de2b263] {\n  margin: 0px;\n  padding: 0px;\n  border: none;\n  height: 200px;\n  width: 320.5px;\n  max-width: 100%;\n  touch-action: none;\n  background-color: rgb(244, 245, 246);\n}\n", map: {"version":3,"sources":["../mesrajaya/mesrajaya/public/js/delivery_trip_web/components/SignatureField.vue"],"names":[],"mappings":";AA8DA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AACA;AAEA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AACA;AAEA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,oCAAA;AACA","file":"SignatureField.vue","sourcesContent":["<template>\n  <div class=\"text-center\">\n    <div class=\"signature-field mx-auto\" v-show=\"editing\">\n      <canvas\n        class=\"signature-canvas\"\n        ref=\"signCanvas\"\n        width=\"320\"\n        height=\"200\"\n      ></canvas>\n      <div class=\"signature-btn-row editing\">\n        <button\n          type=\"button\"\n          class=\"signature-reset btn icon-btn\"\n          @click=\"clearSignature\"\n        >\n          <svg class=\"icon icon-sm\">\n            <use class=\"\" href=\"#icon-refresh\"></use>\n          </svg>\n        </button>\n      </div>\n    </div>\n    <img class=\"signature-canvas\" :src=\"value\" v-show=\"!editing\" v-if=\"value\" />\n    <div class=\"signature-canvas mx-auto\" v-show=\"!editing\" v-else></div>\n  </div>\n</template>\n\n<script>\nimport SignaturePad from \"signature_pad\";\n\nlet signCanvas;\nexport default {\n  name: \"SignatureField\",\n  props: [\"value\", \"editing\"],\n  emits: [\"input\"],\n  data: () => {\n    return {};\n  },\n  mounted() {\n    signCanvas = new SignaturePad(this.$refs.signCanvas);\n    signCanvas.addEventListener(\"endStroke\", () => {\n      this.$emit(\"input\", signCanvas.toDataURL());\n    });\n  },\n  watch: {\n    value(newVal, oldVal) {\n      if (newVal) {\n        signCanvas.fromDataURL(newVal);\n      } else {\n        signCanvas.fromDataURL(\"\");\n      }\n    },\n  },\n  methods: {\n    clearSignature() {\n      signCanvas.clear();\n      this.$emit(\"input\", signCanvas.toDataURL());\n    },\n  },\n};\n</script>\n\n<style scoped>\n.signature-field {\n  min-height: 110px;\n  background: #fff;\n  border: 1px solid #f4f5f6;\n  border-radius: 6px;\n  position: relative;\n  width: 320px;\n}\n\n.signature-btn-row {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n}\n\n.signature-canvas {\n  margin: 0px;\n  padding: 0px;\n  border: none;\n  height: 200px;\n  width: 320.5px;\n  max-width: 100%;\n  touch-action: none;\n  background-color: rgb(244, 245, 246);\n}\n</style>\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-1de2b263"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../mesrajaya/mesrajaya/public/js/delivery_trip_web/components/SignatureField.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__